import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import TagManagerUtils from './utils/TagManagerUtils';
import Main from './domain/main/Main';
import store from './store/store';
import './index.css';

const storage = store();
TagManagerUtils.init(process.env.GOOGLE_TAG_MANAGER_ID);


ReactDOM.render(
  <Provider store={storage}>
    <Main />
  </Provider>,
  document.getElementById('root')
);
